<div
  class="position-relative h-100 overflow-hidden"
  *ngIf="{ copyIcon: copyIcon$ | async } as observables"
>
  <atx-horizontal-scroll-arrows
    *ngIf="!portable"
    [hostElement]="containerRef"
  ></atx-horizontal-scroll-arrows>
  <div
    class="prepack-grid"
    #containerRef
    [class.portable]="portable"
    data-e2e="advanced-mdo-grid"
  >
    <div
      class="grid-header"
      [class.portable]="portable"
      [style.grid-template-columns]="columnConfig"
    >
      <div class="cell first header pl-4">
        {{ headerName }}
      </div>
      <div
        class="cell header-cell position-relative"
        [atxTooltip]="fullTitle"
        *ngFor="let column of columns; let colIndex = index; trackBy: trackByFn"
      >
        <button
          class="icon-button delete"
          data-e2e="advanced-mdo-shop-clear-btn"
          [class.d-none]="!shopTotals?.[column.id]"
          (click)="clearShop.emit(column)"
        >
          <fa-icon [icon]="['fas', 'trash']"></fa-icon>
        </button>
        <div class="title-wrapper w-100">
          <ng-container *ngIf="!portable; else portableTitle">
            <ng-container *ngTemplateOutlet="fullTitle"></ng-container>
          </ng-container>
          <ng-template #fullTitle>
            <div
              class="name"
              [attr.data-e2e]="'advanced-mdo-shop-' + column.displayId"
            >
              {{ column.displayId }}
            </div>
            <div class="name">
              {{ column.name }}
            </div>
            <div class="address">
              {{ column.address }}
            </div>
          </ng-template>
          <ng-template #portableTitle>
            <div class="name text-center portable">
              {{ column.name }}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div
      class="grid-body"
      epcGridNavigation
      rowSelector="[mdoNavRow]"
      cellSelector="[mdoNavCell]"
      disabledSelector="mdoNavDisabled"
      cdkDropListGroup
    >
      <ng-container
        *ngFor="let row of rowItems; let rowIndex = index; trackBy: trackByFn"
      >
        <div
          class="grid-row"
          mdoNavRow
          [style.grid-template-columns]="columnConfig"
        >
          <div class="cell product-info overflow-hidden first">
            <ng-container
              *ngTemplateOutlet="
                rowHeadTemplate;
                context: { row: row, rowIndex: rowIndex }
              "
            ></ng-container>
            <ng-container *ngIf="!rowHeadTemplate">{{ rowIndex }}</ng-container>
          </div>
          <div
            cdkDropList
            class="cell position-relative value"
            (cdkDropListEntered)="setCopyEndCoords(colIndex, rowIndex)"
            (cdkDropListDropped)="copy()"
            [attr.data-e2e]="'advanced-mdo-cell-' + colIndex + '-' + rowIndex"
            [ngClass]="{
              'horizontal-copy': restrictVerticalCopy,
              preview: isInCoords(colIndex, rowIndex),
              'copy-border-top': rowIndex === displayCopyCoords.start.y,
              'copy-border-left': colIndex === displayCopyCoords.start.x,
              'copy-border-right': colIndex === displayCopyCoords.end.x,
              'copy-border-bottom': rowIndex === displayCopyCoords.end.y,
              'copy-destination':
                rowIndex === copyCoords.end.y && colIndex === copyCoords.end.x
            }"
            (focusin)="toggleCellFocus(true, { x: colIndex, y: rowIndex })"
            *ngFor="
              let column of columns;
              let colIndex = index;
              trackBy: trackByFn
            "
          >
            <ng-container
              *ngTemplateOutlet="
                cellTemplate;
                context: {
                  column: column,
                  row: row,
                  rowIndex: rowIndex,
                  colIndex: colIndex,
                  portable: portable
                }
              "
            ></ng-container>
            <ng-container *ngIf="!cellTemplate">{{ row[column] }}</ng-container>
            <div
              class="drag-handler"
              cdkDrag
              (cdkDragStarted)="setCopyStartCoords(colIndex, rowIndex)"
              [cdkDragPreviewClass]="'opacity-1'"
              [cdkDragLockAxis]="restrictVerticalCopy ? 'x' : null"
            >
              <fa-icon
                [icon]="
                  restrictVerticalCopy
                    ? ['fas', 'arrows-left-right']
                    : ['fas', 'arrows-up-down-left-right']
                "
              ></fa-icon>
            </div>
          </div>
        </div>

        <div
          class="row-details"
          [style.width]="containerRef.offsetWidth + 'px'"
          [style.grid-column-end]="columns.length"
          [class.opened]="row.opened"
          *ngIf="rowDetailsTemplate"
        >
          <ng-container
            *ngTemplateOutlet="rowDetailsTemplate; context: { row: row }"
          ></ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
